export const availableAuthServices = [
    { id: "1", name: "facebook", iconSrc: "/images/social-icons/facebook.png" },
    { id: "2", name: "google", iconSrc: "/images/social-icons/google.png" },
    { id: "3", name: "github", iconSrc: "/images/social-icons/github.png" },
    { id: "4", name: "linkedin", iconSrc: "/images/social-icons/linkedin.png" },
    { id: "5", name: "discord", iconSrc: "/images/social-icons/discord.png" },
];

export const whitelistedPaths = ["/", "/termsandconditions", "/dataprotection", "/imprint", "/login", "/setup", "/new", "/new/*"];
